const start = "\n\n[G3: regras individuais]\n";
const end = "\n[/G3: regras individuais]";
// The versioned field already participates in draft, approval and instructions.
// Only an exact, well-formed suffix is interpreted; all other text is preserved.
export function splitIndividualRules(value: string): { general: string; rules: string[] } {
  // Core trims bounded text. Older saves could then re-wrap the unrecognized
  // block as general text; recover every well-formed consecutive suffix.
  let remaining = value.replace(/\r\n/g, "\n");
  const marker = "[G3: regras individuais]\n";
  let rules: string[] = [];
  let found = false;
  while (true) {
    const ending = remaining.trimEnd();
    const index = ending.lastIndexOf(marker);
    if (index < 0 || (index > 0 && !ending.slice(0,index).endsWith("\n\n")) || !ending.endsWith(end)) break;
    const lines = ending.slice(index + marker.length, -end.length).split("\n");
    if (lines.some(line => !line.startsWith("- "))) break;
    found = true;
    rules = [...lines.map(line => line.slice(2)), ...rules];
    remaining = ending.slice(0,index).replace(/\n\n$/, "");
  }
  return found ? { general: remaining, rules: [...new Set(rules)] } : { general: value, rules: [] };
}
export function joinIndividualRules(general: string, rules: readonly string[]): string {
  return rules.length ? `${general}${start}${rules.map(rule => `- ${rule.replace(/[\r\n]/g, " ")}`).join("\n")}${end}` : general;
}
